import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { groupedCategoryAccountsByAccountFilterSelector } from "./groupedCategoryAccountsByAccountFilterSelector";

export const accountFiltersByCategoryIdSelector = createDraftSafeSelector(
  [groupedCategoryAccountsByAccountFilterSelector],
  (data) => {
    return data?.includedAccounts;
  },
);
